import React, { useEffect, useState } from "react";
import { useAddRecipientMutation, useGetRecipientsQuery } from "../store/api/recipientApi"; // Мутация для добавления через Redux или API
import TextField from "../components/TextField";
import Button from "../components/Button";
import { useLocation, useNavigate } from "react-router";

const AddRecipientForm = () => {
  const location = useLocation();

  const [formData, setFormData] = useState({
    phone: "",
    birth_date: "",
    first_name: "",
    last_name: "",
    address: "",
    ppt_inn: "",
  });
  const [addRecipient, { isLoading }] = useAddRecipientMutation(); // Мутация для создания получателя
  const { refetch } = useGetRecipientsQuery();
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await addRecipient(formData).unwrap(); // Вызов API
      refetch();
      alert("Получатель успешно добавлен!");
      navigate('/recipient')
    } catch (err) {
      console.error(err);
      alert("Ошибка при добавлении получателя.");
    }
  };

  useEffect(() => {
    if (location.state?.guid) setFormData(location.state)
  }, location.state)

  return (
    <div className="recipient-list">
      <div className="top-title">
        <p className="form-title">
          {formData.guid ? "Измнить данные" : "Добавить получателя"}
        </p>
      </div>
      <form onSubmit={handleSubmit} className="ordform-space">
        <div className="ordform-group">
          <TextField
            label="Имя"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            placeholder="Введите имя"
          />
        </div>

        <div className="ordform-group">
          <TextField
            label="Фамилия"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            placeholder="Введите фамилию"
          />
        </div>

        <div className="ordform-group">
          <TextField
            label="ИНН"
            name="ppt_inn"
            value={formData.ppt_inn}
            onChange={handleChange}
            placeholder="ИНН"
          />
        </div>

        <div className="ordform-group">
          <TextField
            label="Адрес"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Введите адрес"
          />
        </div>
      </form>
      <div className="person-footer">
        <Button type="submit" disabled={isLoading} onClick={handleSubmit}>
          {isLoading ? "Загрузка..." : (formData.guid ? "Сохранить" : "Сохранить")}
        </Button>
      </div>
    </div>
  );
};

export default AddRecipientForm;
